import { factory, getResponseCamelization } from '@repo-level/core-front';
import { isCMSV3 } from 'helpers/conf';
import type { CMSApiBase, CMSGroupParams, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface BonanzaFaqItem {
  question: string;
  answer: string;
}

export interface BonanzaFaq extends CMSGroupParams {
  items: BonanzaFaqItem[];
}

export interface HowToParticipateCard {
  img?: CMSImageBase;
  title?: string;
  description: string;
  id: number;
  gradientHex?: string;
  cardImage: CMSImageBase;
}

export interface Title extends CMSGroupParams {
  text: string;
}

export interface Description extends CMSGroupParams {
  text: string;
}

export interface HowToParticipate extends CMSGroupParams {
  cards: HowToParticipateCard[];
}

export interface IBonanzaBgStatusItem {
  bg: CMSImageBase;
  promoLvl: string;
}

export interface BonanzaStatusItems {
  character: CMSImageBase;
  label: CMSImageBase;
  labelMob: CMSImageBase;
  promoLevel: string;
}

export interface menuItems {
  bg: CMSImageBase;
  unlogged: CMSImageBase;
  unloggedMob: CMSImageBase;
  unLoggedLabelText: string;
  returnToStartFresh: string;
  openBonus: string;
  yourProgress: string;
  yourReward: string;
}

export interface BonanzaPromoApi extends CMSApiBase {
  title: string;
  titles: Title[];
  descriptions: Description[];
  mobImg: CMSImageBase;
  titleImg: CMSImageBase;
  titleImgMob: CMSImageBase;
  bg: CMSImageBase;
  bgMob: CMSImageBase;
  menu: menuItems;
  bonanzaStatus: BonanzaStatusItems[];
  howToParticipateTitle: string;
  howToParticipate: HowToParticipate[];
  faqTitle: string;
  faq: BonanzaFaq[];
  start: string;
  end: string;
  congratulations: string;
  enjoyYourPlay: string;
  terms: string;
  promoPrefix: string;
  bgByStatus: IBonanzaBgStatusItem[];
}

export const bonanzaPromoV3 = factory(
  (r) => (lang: string) =>
    r<BonanzaPromoApi>('get', buildCmsUrl({ path: 'bonanza-promo', lang }))
);

export const bonanzaPromoV4 = factory(
  (r) => (lang: string) =>
    r<BonanzaPromoApi>(
      'get',
      buildCmsUrl({
        path: 'bonanza-promo',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const bonanzaPromo = isCMSV3 ? bonanzaPromoV3 : bonanzaPromoV4;
